export default "__VITE_ASSET__DiwLxLIU__"